import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Encontrar o contêiner do YouTube ou iframe
    this.findYouTubeElementAndInsertWidgets();
  }

  findYouTubeElementAndInsertWidgets() {
    // Opção 1: Procurar por iframe do YouTube
    const youtubeIframe = document.querySelector('iframe[src*="youtube.com"]');

    // Opção 2: Procurar pelo contêiner com ID específico
    const youtubeContainer = document.querySelector('.youtube-placeholder, #youtube-video, .youtube-video, [data-youtube-container]');

    // Escolher o elemento alvo (iframe ou container)
    const targetElement = youtubeIframe || youtubeContainer;

    if (targetElement) {
      this.insertWidgetsBeforeElement(targetElement);
    } else {
      setTimeout(() => {
        this.findYouTubeElementAndInsertWidgets();
      }, 1000);
    }
  }

  insertWidgetsBeforeElement(targetElement) {
    // Criar o container flexível para os widgets
    const flexContainer = document.createElement('div');
    flexContainer.style.display = 'flex';
    // flexContainer.style.justifyContent = 'center';
    // flexContainer.style.alignItems = 'center';
    flexContainer.style.flexWrap = 'wrap';
    flexContainer.style.gap = '20px';
    flexContainer.style.margin = '0 auto 20px auto'; // Adicionado margem inferior

    // Inserir o container antes do elemento alvo
    targetElement.parentNode.insertBefore(flexContainer, targetElement);

    // Carregar os widgets dentro do container
    this.loadTripAdvisorWidgets(flexContainer);
    this.fixWidgetAccessibility(flexContainer);
  }

  loadTripAdvisorWidgets(container) {
    // Carregar o widget de avaliação
    this.loadRatingWidget(container);

    // Carregar o widget de certificado de excelência
    this.loadCertificateWidget(container);
  }

  loadRatingWidget(container) {
    // Criar um wrapper para o widget de avaliação
    const ratingWrapper = document.createElement('div');
    ratingWrapper.className = 'tripadvisor-rating-widget';
    // ratingWrapper.style.width = '240px';
    ratingWrapper.style.overflow = 'hidden';

    // Usar HTML simplificado sem a imagem
    ratingWrapper.innerHTML = `
      <div id="TA_cdsratingsonlynarrow509" class="TA_cdsratingsonlynarrow">
        <ul id="NBNxUnpl" class="TA_links SjIOCzZ">
          <li id="72PD1hIRqgPH" class="1XZDSyk2">
            <a target="_blank" href="https://www.tripadvisor.com.br/Attraction_Review-g303441-d8662454-Reviews-Tour_de_Boteco-Curitiba_State_of_Parana.html">
              Tour de Boteco
            </a>
          </li>
        </ul>
      </div>
    `;

    // Adicionar o wrapper ao container
    container.appendChild(ratingWrapper);

    // Criar o script do TripAdvisor para o widget de avaliação
    this.createTripAdvisorScript(
      "https://www.jscache.com/wejs?wtype=cdsratingsonlynarrow&uniq=509&locationId=8662454&lang=pt&border=true&shadow=false&display_version=2",
      () => this.adjustWidget(ratingWrapper, 'iframe', 130)
    );
  }

  loadCertificateWidget(container) {
    // Criar um wrapper para o widget de certificado
    const certWrapper = document.createElement('div');
    certWrapper.className = 'tripadvisor-cert-widget';
    // certWrapper.style.width = '180px';
    certWrapper.style.overflow = 'hidden';

    // Usar HTML simplificado sem a imagem
    certWrapper.innerHTML = `
      <div id="TA_certificateOfExcellence319" class="TA_certificateOfExcellence">
        <ul id="WsnKtON" class="TA_links Gjl6gNZplt81">
          <li id="g22euFE2" class="AsWq3YRBnOz1">
            <a target="_blank" href="https://www.tripadvisor.com.br/Attraction_Review-g303441-d8662454-Reviews-Tour_de_Boteco-Curitiba_State_of_Parana.html">
              Tour de Boteco
            </a>
          </li>
        </ul>
      </div>
    `;

    // Adicionar o wrapper ao container
    container.appendChild(certWrapper);

    // Criar o script do TripAdvisor para o widget de certificado
    this.createTripAdvisorScript(
      "https://www.jscache.com/wejs?wtype=certificateOfExcellence&uniq=319&locationId=8662454&lang=pt&year=2024&display_version=2",
      () => this.adjustWidget(certWrapper, 'iframe', 100)
    );
  }

  createTripAdvisorScript(src, callback) {
    // Verificar se o script já existe para evitar duplicação
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
      existingScript.remove();
    }

    // Criar o script
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    script.setAttribute('data-loadtrk', '');
    script.onload = function() {
      this.loadtrk = true;
      if (callback) setTimeout(callback, 1000);
    };

    // Adicionar o script ao corpo do documento
    document.body.appendChild(script);
  }

  // O script do Tripadvisor troca o HTML do widget: imagem sem alt e link sem texto.
  // Corrige o que ele injetar, quando injetar.
  fixWidgetAccessibility(container) {
    const fix = () => {
      container.querySelectorAll("img:not([alt])").forEach(img => img.setAttribute("alt", ""))
      container.querySelectorAll("a:not([aria-label])").forEach(link => {
        if (!link.textContent.trim()) link.setAttribute("aria-label", "Tour de Boteco no Tripadvisor")
      })
    }
    fix()
    new MutationObserver(fix).observe(container, { childList: true, subtree: true })
  }

  adjustWidget(container, selector, height) {
    // Encontrar o elemento a ser ajustado
    const element = container.querySelector(selector);
    if (element) {
      // Ajustar o elemento para garantir exibição correta
      element.loading = 'lazy';
      element.style.width = '100%';
      element.style.maxWidth = '100%';
      element.style.height = `${height}px`;
      element.style.border = 'none';
      element.style.overflow = 'hidden';
    }
  }
}
